/* eslint-disable no-useless-escape --
 * La barra invertida de `<\/script>` es deliberada: la secuencia </script> sin
 * escapar cerraria el bloque antes de tiempo si este archivo quedara incrustado
 * en una pagina. En un literal de plantilla `\/` produce `/`, asi que el HTML
 * generado es identico.
 */

/**
 * Vista previa antes de imprimir.
 *
 * Los comprobantes se abrían llamando a `window.print()` en cuanto cargaba la
 * ventana: el diálogo de impresión aparecía sin que nadie hubiera visto el
 * documento. Eso obliga a imprimir —o cancelar a ciegas— para recién después
 * descubrir que el cliente estaba mal, que faltaba un artículo o que la
 * condición no era la que correspondía. Con papel de por medio, revisar
 * después sale caro.
 *
 * Ahora el documento se muestra y la impresión es una decisión. La barra se
 * oculta al imprimir, así que el papel sale idéntico a como salía antes.
 */

export const ESTILOS_VISTA_PREVIA = `
  /* Barra de la vista previa. No se imprime. */
  .barra-vista-previa {
    position: sticky; top: 0; z-index: 10;
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
    padding: 10px 16px; margin: -12mm -14mm 12mm;
    background: #18181b; color: #fafafa;
    font-family: Arial, Helvetica, sans-serif; font-size: 13px;
  }
  .barra-vista-previa .titulo { font-weight: bold; letter-spacing: .3px; }
  .barra-vista-previa .acciones { display: flex; gap: 8px; }
  .barra-vista-previa button {
    font-family: inherit; font-size: 13px; font-weight: bold;
    padding: 8px 18px; border-radius: 8px; border: 0; cursor: pointer;
  }
  .barra-vista-previa .imprimir { background: #eab308; color: #18181b; }
  .barra-vista-previa .imprimir:hover { background: #facc15; }
  .barra-vista-previa .cerrar { background: transparent; color: #a1a1aa; }
  .barra-vista-previa .cerrar:hover { color: #fafafa; }

  @media print {
    .barra-vista-previa { display: none !important; }
  }
`;

/**
 * La barra, con su propio manejo de eventos.
 *
 * Los botones se enganchan con `addEventListener` y no con `onclick` en el
 * atributo: el documento se escribe en una ventana nueva y un atributo con
 * comillas se rompe fácil al interpolarlo.
 */
export function barraVistaPrevia(titulo = 'Vista previa') {
    return `
  <div class="barra-vista-previa">
    <span class="titulo">${titulo}</span>
    <span class="acciones">
      <button type="button" class="cerrar" id="vp-cerrar">Cerrar</button>
      <button type="button" class="imprimir" id="vp-imprimir">Imprimir</button>
    </span>
  </div>
  <script>
    document.getElementById('vp-imprimir').addEventListener('click', function () { window.print(); });
    document.getElementById('vp-cerrar').addEventListener('click', function () { window.close(); });
    // Ctrl+P hace lo mismo que el botón; el navegador ya lo maneja solo.
  <\/script>`;
}

/** Abre el documento en una ventana nueva, sin imprimirlo. */
export function abrirVistaPrevia(html, { ancho = 900, alto = 760 } = {}) {
    const ventana = window.open('', '_blank', `width=${ancho},height=${alto}`);
    if (!ventana) {
        // El navegador bloqueó la ventana emergente. Decirlo es mejor que no
        // hacer nada: desde afuera parece que el botón no anda.
        // eslint-disable-next-line no-alert
        window.alert('El navegador bloqueó la ventana. Permití las ventanas emergentes de este sitio para ver el comprobante.');
        return null;
    }
    ventana.document.write(html);
    ventana.document.close();
    return ventana;
}
